import { makeVar, useReactiveVar } from '@apollo/client';
import useMobile from '../hooks/useMobile';
const sidebarStates = new Map();
const DEFAULT_SIDEBAR_ID = 'default';
/**
 * This hook is used to toggle the ScreenLayout sidebar.
 * @param name - Optional name for the sidebar instance (defaults to 'default')
 */
export function useScreenSidebar(id) {
    const sidebarName = id !== null && id !== void 0 ? id : DEFAULT_SIDEBAR_ID;
    const isMobile = useMobile();
    // Get or create the reactive var for this sidebar
    if (!sidebarStates.has(sidebarName)) {
        sidebarStates.set(sidebarName, makeVar(!isMobile));
    }
    const sidebarVar = sidebarStates.get(sidebarName);
    const state = useReactiveVar(sidebarVar);
    return {
        state,
        toggle: () => sidebarVar(!state),
        set: (open) => sidebarVar(open),
    };
}
